import marketChangePrice from '@/components/market/market-change-price/market-change-price.vue';
import marketPriceChangeChart from '@/components/market/market-price-change-chart/market-price-change-chart.vue';
import Contract from '@/models/contract';

export default {
  components: {
    marketChangePrice,
    marketPriceChangeChart,
  },
  props: {
    promo: {
      type: Object,
    },
    header: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    contract() {
      return new Contract(this.promo);
    },
    iconModifiers() {
      return {
        'market-biggest-gains-element__icon': true,
        [`market-biggest-gains-element__icon--${this.iconTargetClass}`]: this.iconTargetClass,
      };
    },
    iconTargetClass() {
      return (this.promo.isGain) ? 'price-up' : 'price-down';
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-biggest-gains-element/market-biggest-gains-element.js